import { Navigate, RouteObject } from "react-router-dom";
import React from "react";
import QuotaPage from "../../Pages/Admin/Edition/Ai/QuotaPage";
import PropertyPage from "../../Pages/Admin/Edition/Ai/PropertyPage";
import AuditLogsPage from "../../Pages/Admin/Edition/Ai/AuditLogsPage";

const AiRouting: RouteObject[] = [
    {
        index: true,
        element: <QuotaPage />,
    },
    {
        path: 'configuration',
        element: <PropertyPage />,
    },
    {
        path: 'settings',
        element: <Navigate to="../configuration" replace />,
    },
    {
        path: 'audit-logs',
        element: <AuditLogsPage />,
    }
];

export default AiRouting;
